export { default as PageTitle } from './PageTitle';
export type { Props as PageTitleProps } from './PageTitle';
